module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-form footer-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "contact-footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-padding"
  }, [_c('div', {
    staticClass: "contact-form-inputs"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.WhitepaperContent.heading))]), _vm._v(" "), (_vm.WhitepaperContent.img) ? _c('img', {
    staticClass: "whitepaper-image",
    attrs: {
      "src": _vm.getImgUrl(_vm.WhitepaperContent.img)
    }
  }) : _vm._e(), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formIsSubmitted),
      expression: "!formIsSubmitted"
    }],
    staticClass: "sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.WhitepaperContent.subheading)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formIsSubmitted),
      expression: "!formIsSubmitted"
    }]
  }, [_c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }],
    staticClass: "input-element",
    attrs: {
      "id": "contact-form-email-address",
      "type": "email",
      "name": "email",
      "placeholder": "Email address",
      "required": ""
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "Company name",
      "required": ""
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.website),
      expression: "website"
    }],
    staticClass: "input-element",
    attrs: {
      "type": "text",
      "name": "website",
      "placeholder": "Company website",
      "required": ""
    },
    domProps: {
      "value": (_vm.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.website = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formError),
      expression: "formError"
    }],
    staticClass: "contact-form-error",
    domProps: {
      "innerHTML": _vm._s(_vm.formError)
    }
  }), _vm._v(" "), (!_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.userClickedSubmit
    }
  }, [_vm._v(_vm._s(_vm.WhitepaperContent.buttonText))]) : _vm._e(), _vm._v(" "), (_vm.submitInProgress) ? _c('button', {
    staticClass: "form-button form-button-progress",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_vm._v("submitting your info "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formIsSubmitted),
      expression: "formIsSubmitted"
    }],
    staticClass: "contact-form-success"
  }, [_c('div', {
    staticClass: "contact-form-success-header"
  }, [_vm._v("\n        Thanks!\n      ")]), _vm._v(" "), _c('span', [_vm._v("\n        Click "), _c('a', {
    attrs: {
      "href": _vm.WhitepaperContent.link,
      "download": "",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" to view and download the document.\n      ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n        Click "), _c('a', {
    attrs: {
      "href": _vm.WhitepaperContent.videoLink,
      "download": "",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(" to view the webinar video.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mikmak-logo-black.png"),
      "alt": "MikMak"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-links"
  }, [_c('a', {
    attrs: {
      "href": _vm.getLink('#our-software')
    }
  }, [_vm._v("Software")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('careers')
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('about')
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "dot"
  }, [_vm._v("·")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.getLink('privacy')
    }
  }, [_vm._v("Privacy policy")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© 2015-" + _vm._s(_vm.currentYear) + " TIPO Entertainment, Inc.")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://instagram.com/MikMakTV/",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/MikMakdotTV",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mikmaktv",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCGT0qpoynvsBolIES_xAr0w",
      "target": "new"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-play",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inc-500"
  }, [_c('a', {
    attrs: {
      "href": "https://www.inc.com/profile/mikmak",
      "target": "new"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/inc-500.png"),
      "alt": "Inc 500"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c30b924"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Whitepaper/Holiday2019.vue
// module id = 466
// module chunks = 0